// start:ng42.barrel
export * from './ICharge';
export * from './IRate';
export * from './IRateChange';
export * from './IRatePointsAndCashOptions';
export * from './IRateRule';
export * from './IRoom';
export * from './IRoomCharge';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/RateRule/index.ts